import { authRequest } from './utils';

export const getSkills = async (config = undefined) => {
  const url = `admin/skills/`;
  return await authRequest.get(url, config);
};

export const postSkill = async (data, config = undefined) => {
  const url = `admin/skills/`;
  return await authRequest.post(url, data, config);
};
